<template>
  <div class="pagination">
    <div class="pagination-numbers" data-external="pagination-numbers">
      <strong>{{ currentPageRange }}</strong> {{ t('of') }} <strong>{{ totalCount }} </strong>
    </div>
    <div class="pagination-buttons">
      <FriedIconButton
        data-external="pagination-prev-button"
        :disabled="isFirstPage"
        @click="$emit('update', -1)"
      >
        <FriedIcon icon="chevron-left" />
      </FriedIconButton>
      <FriedIconButton
        data-external="pagination-next-button"
        :disabled="isLastPage"
        @click="$emit('update', 1)"
      >
        <FriedIcon icon="chevron-right" />
      </FriedIconButton>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    offset: {
      type: Number,
      default: 0,
    },
    itemsPerPage: {
      type: Number,
      default: 15,
    },
  },
  emits: ['update'],
  setup(props) {
    const { t } = useI18n();
    const startRange = computed(() =>
      props.totalCount > 0 ? props.offset * props.itemsPerPage + 1 : 0
    );

    const endRange = computed(() =>
      Math.min(startRange.value + props.itemsPerPage - 1, props.totalCount)
    );

    const currentPageRange = computed(() => `${startRange.value}-${endRange.value}`);
    const isFirstPage = computed(() => props.offset === 0);
    const isLastPage = computed(() => endRange.value >= props.totalCount);

    return {
      startRange,
      endRange,
      isFirstPage,
      isLastPage,
      currentPageRange,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  margin: var(--spacing-50) 0;
  justify-content: flex-end;
  color: var(--gray-39);

  .pagination-buttons {
    display: flex;
    align-items: center;
    gap: var(--spacing-25);
    margin-left: var(--spacing-100);
  }
}
</style>
